export default {
  header: 'Besteloverzicht',
  buttons: {
    checkout: 'Veilig afrekenen',
    continue: 'Doorgaan',
    add_products: '+ Producten toevoegen',
    add_items: '+ Meer items toevoegen',
    menu: 'Menu',
  },
  empty_order_basket: {
    description: 'Je winkelwagen is leeg <br/> Voeg items toe om te beginnen',
  },
  promo_code_banner: {
    single_use: '{{discount}} korting - {{code}}',
    multi_use: '{{discount}} korting op {{count}} bestellingen - {{code}}',
    redeem: 'INWISSELEN',
    redeemed: 'INGEWISSELD',
  },
  upsell: {
    title: 'Anderen bestellen ook',
  },
  rewards: {
    title: 'Betalen met punten',
    description: '<highlight>Log in</highlight> om te betalen met punten',
  },
  already_member: 'Al lid?',
  sign_in: 'Inloggen',
  summary: {
    subtotal: 'Subtotaal',
    delivery: 'Bezorging',
    pickup: 'Afhalen',
    total: 'Totaal',
    free: 'Gratis',
  },
  footer: {
    member_earning: '+{{points}} pts na betaling · {{balance}} pts saldo',
    guest_earning: 'Meld je aan om punten te verdienen op deze bestelling',
  },
};
